import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {XCloseIcon} from '@/components/ui/icon/Icon'
import {SelectTrigger} from '@/components/ui/select-atoms/SelectAtoms'
import {InputSelectUserProps} from '@/features/users/components/input-select-user/InputSelectUser'
import {forwardRef} from 'react'

export const InputSelectUserTrigger = forwardRef<HTMLSelectElement, Omit<InputSelectUserProps, 'onChange'>>(
    ({disabled, value, placeholder, errorMessage, onClear, isLoading, displayValue}, ref) => {
        return (
            <SelectTrigger
                ref={ref}
                placeholder={placeholder}
                fullWidth
                value={value?.id}
                displayValue={() => (
                    <Flexbox justify="space-between" align="center" gap={2} fullWidth>
                        {displayValue ? (
                            displayValue(value?.id)
                        ) : (
                            <span>
                                {value?.fullName}
                                {` `}
                                {value?.specializationName ? <span>({value.specializationName})</span> : null}
                            </span>
                        )}
                        {onClear && (
                            <XCloseIcon
                                role="button"
                                onClick={e => {
                                    e.preventDefault()
                                    e.stopPropagation()
                                    onClear()
                                }}
                            />
                        )}
                    </Flexbox>
                )}
                hasError={!!errorMessage}
                disabled={disabled}
                isLoading={isLoading}
            />
        )
    }
)
